{
  "refinement.life.window.move": "Pencereyi taşı · Alt + yön tuşları",
  "refinement.life.window.minimize": "Pencereyi küçült",
  "refinement.life.window.restoreSize": "Pencere boyutunu geri yükle",
  "refinement.life.window.maximize": "Pencereyi büyüt",
  "refinement.life.window.close": "Pencereyi kapat",
  "refinement.life.window.resize": "Pencereyi boyutlandır · yön tuşları",
  "refinement.life.window.linkError": "Bu yaşam alanı veya tablo açılamadı. Bağlantıyı tekrar deneyin.",
  "refinement.life.window.dismiss": "Kapat",
  "refinement.life.window.loading": "Yaşam alanı",
  "refinement.life.window.tableUnavailable": "Bu tablo artık bu alanda bulunmuyor. Başka bir tablo veya Genel Bakış'ı seçin.",
  "refinement.life.calendar.label": "Yaşam takibi takvimi",
  "refinement.life.calendar.moments_one": "anlık",
  "refinement.life.calendar.moments_other": "anlık",
  "refinement.life.calendar.records_one": "kayıt",
  "refinement.life.calendar.records_other": "kayıt",
  "refinement.life.calendar.previous": "Önceki ay",
  "refinement.life.calendar.next": "Sonraki ay",
  "refinement.life.calendar.month": "Ay seç",
  "refinement.life.calendar.today": "Bugün",
  "refinement.life.calendar.monthView": "Ay",
  "refinement.life.calendar.listView": "Liste",
  "refinement.life.calendar.filters": "Filtreler",
  "refinement.life.calendar.hint": "Tüm içeriğini görmek için bir gün seçin. Boş günlerde filtrelerinize uyan kayıt bulunmuyor.",
  "refinement.life.calendar.openDay_one": "{{date}} gününü aç · {{count}} anlık ve kayıt",
  "refinement.life.calendar.openDay_other": "{{date}} gününü aç · {{count}} anlık ve kayıt"
}
